import moment from 'moment';
import { push } from 'react-router-redux';
import { writeErr } from '../components/common/logger';
import { apiPost, apiGet, getHostApi } from './apiWrapper';
import { isFunction, isNullOrUndefined, isString } from './storeFunctions';

const UPDATE_SEARCH_PARAMS = "UPDATE_SEARCH_PARAMS";
const UPDATE_CONTRACT_DATA_CORRECTION = "UPDATE_CONTRACT_DATA_CORRECTION";
const UPDATE_SEARCH_FORM_PARAMS = "UPDATE_SEARCH_FORM_PARAMS";
const UPDATE_SUBJECT_INFO = "UPDATE_SUBJECT_INFO";

export const searchTypes = {
    fullText: 1,
    exactMatch: 2,
};

export const entityTypes = {
    po: 1,
    fo: 2
};

export const listDefaultValues = {
    countryCode: 56,
    addressType: 1,
    contactType: 0,
    documentType: 1,
    dunningLevel: 0
};

export const reportTypes = {
    creditPlus: "creditPlus",
    creditMinus: "creditMinus",
    subjectPlus: "subjectPlus",
    poolPlus: "poolPlus",
    poolMinus: "poolMinus",
    invoicesPlus: "invoicesPlus",
    invoicesMinus: "invoicesMinus",
    dataCorrection: "dataCorrectionContributor",
    dataCorrectionInternal: "dataCorrectionInternal"
};

export const dataCorrectionSection = {
    identification: "identificationHistory",
    addresses: "addressHistory",
    contacts: "contactHistory",
    documents: "documentHistory",
    contracts: "contractHistory"
};

export const dataCorrectionType = {
    string: "string",
    int: "int",
    float: "float",
    date: "date",
    bool: "bool",
    list: "list"
};

export const dataCorrectionAction = {
    insert: "insert",
    delete: "delete",
    update: "update"
};

export const defaultPaging = {
    pageNumber: 1,
    pageSize: 5,
};

export const repiDomain = {
    countries: "repi-countries-codes",
    addresses: "repi-addresses-codes",
    documents: "repi-documents-codes",
    contacts: "repi-contacts-codes",
    dunningLevels: "repi-dunning-levels",
    currencies: "repi-currency-codes",
    products: "repi-product-codes"
};

export const repiSearchFields = {
    name: "name",
    surname: "surname",
    pin: "pin",
    companyId: "companyId",
    birthDate: "birthDate",
    city: "city",
    street: "street",
    zip: "zip",
    houseNo: "houseNumber",
    companyName: "companyName",
    phone: "phone",
    email: "email",
    country: "country",
    candidateId: "candidateId",
    subjectId: "subjectId",
    contributorId: "contributorId",
    contributorSubjectId: "contributorSubjectId",
    contributorContractId: "contributorContractId",
    companyIdFop: "companyIdFop"
};

export const repiSearchRegexps = {
    pin: /^[0-9]{6}\/?[0-9]{3,4}$/,
    phone: /(^\d{3,4}$)|(^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$)/,
    email: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    id: /\d+/,
    ipv4: /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/,
    ipv6: /(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))/
};

export const repiContractFields = {
    dueDate: "dueDate",
    paymentDate: "paymentDate",
    amountTotal: "amountTotal",
    amountPaid: "amountPaid", 
    amountOpen: "amountOpen",
    totalAmount: "totalAmount",
    remainingAmount: "remainingAmount",
    overdueAmount: "overdueAmount",
    dunningLevel: "dunningLevel",
    dataEndDate: "dataEndDate",
    isContractOpen: "isContractOpen"
};

export const repiAddSubjectFields = {
    contributorSubjectId: "contributorSubjectId",
    pin: "pin",
    birthDate: "birthDate",
    surname: "surname",
    name: "name",
    alias: "alias",
    country: "country",
    companyId: "companyId",
    companyName: "companyName",
    shared: "shared"
};

export const repiAddContractFields = {
    contributorContractId: "contributorContractId",
    product: "product",
    currency: "currency",
    totalAmount: "totalAmount",
    remainingAmount: "remainingAmount",
    overdueAmount: "overdueAmount",
    isContractOpen: "isContractOpen",
    dunningLevel: "dunningLevel",
    debtBuyerId: "debtBuyerId",
    startDate: "startDate",
    endDate: "endDate",
    creditorId: "creditorId",
    productOriginal: "productOriginal",
    recallDate: "recallDate",
    shared: "shared"
};

export const repiProductCategories = {
    claimEnforcement: "ClaimEnforcement",
    consumerLoan: "ConsumerLoan",
    creditCard: "CreditCard",
    regularPayment: "RegularPayment"
};

export const repiLimits = {
    dataCorrectionContracts: 10,
    paymentHistoryContracts: 10,
    contactHistoryAddresses: 10
};

const initialState = {
    search: {
        entityType: entityTypes.po,
        searchType: searchTypes.fullText,
        consent: false,
        searchParams: {},
        sharedRegistry: false,
        formExpanded: false,
        searchResult: null,
        isSearching: false,
        error: null
    },
    searchForm: {
        focus: null
    },
    subjectInfos: {},
    dataCorrection: {},
    ts: new Date().valueOf()
};

export const repiActions = {
    repiRedirect: (path) => async (dispatch) => _repiRedirect(path, dispatch),
    updateSearchParams: (newData) => async (dispatch) => _updateSearchParams(newData, dispatch),
    searchCandidates: (searchParams, onSuccess) => async (dispatch) => _searchCandidates(searchParams, onSuccess, dispatch),
    setSearchInputFocus: (name) => async (dispatch) => _setSearchInputFocus(name, dispatch),
    exportRepiReportPdf: (reportType, id, poolGroup, calculationDate) => async (dispatch) => _exportRepiReportPdf(reportType, id, poolGroup, calculationDate, dispatch),
    updateContractHeaderData: (contractId, data) => async (dispatch, getState) => _updateContractHeaderData(contractId, data, dispatch, getState),
    getLastSearchQuery: () => (_, getState) => _getLastSearchQuery(getState),
    getRepiProps: () => () => _getRepiProps(),
    isDataCorrection: (internal) => () => _isDataCorrection(internal),
    isPlus: () => () => _isPlus(),
    isSubject: () => () => _isSubject(),
    convertDate: (date, defaultDate, toStringFormat) => () => _convertDate(date, defaultDate, toStringFormat),
    ensureSubjectInfo: (subjectId) => async (dispatch, getState) => _ensureSubjectInfo(subjectId, dispatch, getState)
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch(action.type){
        case UPDATE_SEARCH_PARAMS:
            return { ...state, search: { ...state.search, ...action.data } };
        case UPDATE_CONTRACT_DATA_CORRECTION:
            return { ...state, dataCorrection: { ...state.dataCorrection, [action.contractId]: { ...action.data } } };
        case UPDATE_SEARCH_FORM_PARAMS:
            return { ...state, searchForm: { ...state.searchForm, ...action.data } };
        case UPDATE_SUBJECT_INFO:
            return { ...state, subjectInfos: { ...state.subjectInfos, [action.subjectId]: { ...action.data } } };
        default:
            return state;
    }
};

function _repiRedirect(path, dispatch) {
    dispatch(push(`/repi${(path.startsWith("/") ? path : "/" + path)}`));
}

function _updateSearchParams(newData, dispatch) {
    dispatch({ type: UPDATE_SEARCH_PARAMS, data: newData });
}

function _searchCandidates(searchParams, onSuccess, dispatch) {
    dispatch({ type: UPDATE_SEARCH_PARAMS, data: { searchResult: null, isSearching: true, error: null, searchParams: {} } });
    apiPost(`${window.babylonApiUrl}/api/repi/search`, {}, searchParams,
        s => {
            if (!isNullOrUndefined(s.error)) {
                dispatch({ type: UPDATE_SEARCH_PARAMS, data: { isSearching: false, error: s.error } });
                return;
            }

            let setSearchParams = {};
            Object.keys(searchParams).forEach(s => {
                if (isNullOrUndefined(searchParams[s]) || (isString(searchParams[s]) && searchParams[s] === ""))
                    return;
                setSearchParams[s] = searchParams[s];
            });

            dispatch({ type: UPDATE_SEARCH_PARAMS, data: {
                searchResult: isNullOrUndefined(s.data) ? null : { ...s.data },
                isSearching: false,
                searchParams: setSearchParams
            }});

            if (isFunction(onSuccess))
                onSuccess();
        },
        e => dispatch({ type: UPDATE_SEARCH_PARAMS, data: { searchResult: null, isSearching: false, error: e, searchParams: {} } })
    );
}

function _setSearchInputFocus(name, dispatch) {
    dispatch({ type: UPDATE_SEARCH_FORM_PARAMS, data: { focus: name } });
}

function _exportRepiReportPdf(reportType, id, poolGroup, calculationDate, dispatch) {
    apiPost(`${getHostApi()}/api/repi/report/export-pdf`, null,
        {
            reportType: reportType,
            id: id,
            sharedRegistry: true,
            poolGroup: poolGroup,
            calculationDate: calculationDate
        },
        (s) => {
            if (isNullOrUndefined(s))
                writeErr('Export failed');
        },
        (e) => {
            writeErr(e);
        }
    )
}

function _updateContractHeaderData(contractId, data, dispatch, getState) {
    const state = getState().repi.dataCorrection[contractId] || {};

    const headerData = {
        startDate: isNullOrUndefined(data.startDate) ? isNullOrUndefined(state.startDate) ? null : state.startDate : data.startDate,
        startDateInput: isNullOrUndefined(data.startDateInput) ? isNullOrUndefined(state.startDateInput) ? null : state.startDateInput : data.startDateInput,
        startDateChanged: isNullOrUndefined(data.startDateChanged) ? isNullOrUndefined(state.startDateChanged) ? false : state.startDateChanged : data.startDateChanged,
        startDateIsValid: isNullOrUndefined(data.startDateIsValid) ? isNullOrUndefined(state.startDateIsValid) ? true : state.startDateIsValid : data.startDateIsValid,
        endDate: isNullOrUndefined(data.endDate) ? isNullOrUndefined(state.endDate) ? null : state.endDate : data.endDate,
        endDateInput: isNullOrUndefined(data.endDateInput) ? isNullOrUndefined(state.endDateInput) ? null : state.endDateInput : data.endDateInput,
        endDateChanged: isNullOrUndefined(data.endDateChanged) ? isNullOrUndefined(state.endDateChanged) ? false : state.endDateChanged : data.endDateChanged,
        endDateIsValid: isNullOrUndefined(data.endDateIsValid) ? isNullOrUndefined(state.endDateIsValid) ? true : state.endDateIsValid : data.endDateIsValid
    };

    dispatch({ type: UPDATE_CONTRACT_DATA_CORRECTION, contractId: contractId, data: headerData })
}

function _getLastSearchQuery(getState) {
    const state = getState().repi.search;
    if (isNullOrUndefined(state.searchParams) || Object.keys(state.searchParams) < 1)
        return "";

    const encodedParams = {};
    Object.keys(state.searchParams).forEach(k => {
        if (isString(state.searchParams[k]))
            encodedParams[k] = encodeURIComponent(state.searchParams[k]);
        else
            encodedParams[k] = state.searchParams[k]
    });

    const params = {
        ...encodedParams,
        entityType: state.searchParams.entityType === entityTypes.fo ? "fo" : "po",
        searchType: state.searchParams.searchType === searchTypes.exactMatch ? "em" : "ft",
        consent: state.searchParams.consent === true,
        sharedRegistry: state.sharedRegistry === true
    };

    return `?${new URLSearchParams(params).toString()}`;
}

function _getRepiProps() {
    let result = {
        subjectId: null,
        reportType: null,
    };

    let pathname = window.location.pathname;
    const match =  pathname.match(/\/repi\/report\/(\w+)\/(\d+)/);

    if (!isNullOrUndefined(match) && match.length >= 3) {
        result.subjectId = parseInt(match[2]);
        result.reportType = match[1];
    }

    return result;
}

function _isDataCorrection(internal) {
    const match = window.location.pathname.match(/repi\/report\/(.*?)\//);
    if (isNullOrUndefined(match) || match.length !== 2)
        return false;

    const reportType = match[1];
    return internal === true
        ? reportType.toLowerCase().includes("DataCorrectionInternal".toLowerCase())
        : reportType.toLowerCase().includes("DataCorrection".toLowerCase())
}

function _isPlus() {
    const match = window.location.pathname.match(/repi\/report\/(.*?)\//);
    if (isNullOrUndefined(match) || match.length !== 2)
        return false;

    const reportName = match[1].toLowerCase();
    const plusReports = ["CreditPlus", "PoolPlus", "SubjectPlus", "DataCorrection"];
    return plusReports.reduce((a, c) => a || reportName.includes(c.toLocaleLowerCase()), false);
}

function _isSubject() {
    const match = window.location.pathname.match(/repi\/report\/(.*?)\//);
    if (isNullOrUndefined(match) || match.length !== 2)
        return false;

    const reportName = match[1].toLowerCase();
    return reportName.includes("subjectplus");
}

function _convertDate(date, defaultDate, toStringFormat) {
    if (isNullOrUndefined(date))
        return defaultDate;

    var validatedDate = moment(date, ["D.M.YYYY", "DD.M.YYYY", "D.MM.YYYY", "DD.MM.YYYY", "YYYY-MM-DD", "YYYY-MM-D", "YYYY-M-DD", "YYYY-M-D"], true);

    return (isNullOrUndefined(defaultDate) && !isNullOrUndefined(toStringFormat))
        ? (validatedDate.isValid() ? validatedDate.format(toStringFormat) : date)
        : (validatedDate.isValid() ? validatedDate.toDate() : defaultDate);
}

function _ensureSubjectInfo(subjectId, dispatch, getState) {
    const subjectInfos = getState().repi.subjectInfos;
    if (!isNullOrUndefined(subjectInfos[subjectId]))
        return;

    dispatch({ type: UPDATE_SUBJECT_INFO, subjectId: subjectId, data: { result: null, isRequesting: true } });
    apiGet(`${getHostApi()}/api/repi/search/${subjectId}`, null,
        s => dispatch({ type: UPDATE_SUBJECT_INFO, subjectId: subjectId, data: { result: s.data, isRequesting: false } }),
        e => dispatch({ type: UPDATE_SUBJECT_INFO, subjectId: subjectId, data: { result: null, isRequesting: false } })
    );
}